import React from "react";
import "./CommonHeader.css";

const CommonHeader = ({ title = "", bgColor, textColor, className = "", style = {}, rightComponent }) => {
  const containerStyle = {
    ...(bgColor ? { background: bgColor } : {}),
    ...style,
  };

  const titleStyle = textColor ? { color: textColor } : undefined;

  return (
    <div className={`commonHeader ${className}`} style={containerStyle}>
      <h1 className="commonHeader__title" style={titleStyle}>
        {title}
      </h1>
      {rightComponent && (
        <div className="commonHeader__right">
          {rightComponent}
        </div>
      )}
    </div>
  );
};

export default CommonHeader;